<div class="header header-error container">
  <div class="mid-header">
    <div class="logo-wrapper d-none d-md-block">
      <a
        rel="home"
        [routerLink]="isInsideUveEditor ? '/page/index' : '/home'"
        class="logo"
        [attr.aria-label]="'common.home.link' | translate"
        data-testing-id="header-home-link-desktop"
      ></a>
    </div>
    <div class="logo-wrapper d-md-none">
      <a
        rel="home"
        [routerLink]="isInsideUveEditor ? '/page/index' : '/home'"
        class="mobile-logo"
        [attr.aria-label]="'common.home.link' | translate"
        data-testing-id="link-home"
      ></a>
    </div>
  </div>
</div>
